import { render, staticRenderFns } from "./SousTraitance.vue?vue&type=template&id=411e5c21&scoped=true"
import script from "./SousTraitance.vue?vue&type=script&lang=js"
export * from "./SousTraitance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411e5c21",
  null
  
)

export default component.exports